AuthRoute = require 'mixins/authenticated-route'

App.SettingsAnalyticsRoute = Em.Route.extend AuthRoute,
  session: Em.inject.service()

  model: ->
    @get('session').get('currentOrganization')
